/**
 * BYO v2 — `nexla_utils` helper reference.
 *
 * Discoverable documentation for the helpers available on the `nexla_utils`
 * object passed into `process(file_path, nexla_utils, …)`. Surfaced in the
 * editor so authors know what they can call (esp. the publish_*_log helpers
 * whose output shows up in the run logs).
 */

export interface NexlaUtilHelper {
  signature: string;
  description: string;
}

export const NEXLA_UTILS_HELPERS: ReadonlyArray<NexlaUtilHelper> = Object.freeze([
  {
    signature: 'nexla_utils.publish_info_log(message)',
    description: 'Emit an INFO log line, visible in the run logs.',
  },
  {
    signature: 'nexla_utils.publish_warning_log(message)',
    description: 'Emit a WARNING log line, visible in the run logs.',
  },
  {
    signature: 'nexla_utils.publish_error_log(message)',
    description: 'Emit an ERROR log line, visible in the run logs.',
  },
]);
